import React from 'react';
import { Images, PermissionList, RolePermission } from 'utils';
import { SimpleTooltip, TextRow } from 'components';

export const goalSectionHead = [
    { name: 'name', title: 'Section Name', custom: false },
    { name: 'type', title: 'Type', custom: false, disabled: true },
    { name: 'action', title: 'Action', custom: false, width: '100px' },
];

export const goalSectionBody = [
    { rowText: (item) => <TextRow name={item?.name} /> },
    {
        rowText: (item) => (
            <div>
                {item?.system ? <div className="domain-table-system">System</div> : <div className="domain-table-custom">Custom</div>}
            </div>
        ),
    },
    RolePermission([PermissionList.SYSTEM_SERVICE_TYPES?.code]) && {
        button: (cb, item) =>
            item?.system ? (
                <SimpleTooltip title={'System sections cannot be edited'} placement="bottom" arrow>
                    <img src={Images.infoCircle} alt="flag" />
                </SimpleTooltip>
            ) : (
                <div>
                    <img style={{ cursor: 'pointer' }} src={Images.edit} alt="edit" onClick={() => cb('editSection')} />
                </div>
            ),
        notClickable: true,
    },
];

export const GOAL_SECTION_ACTION_TYPE = 'GET_SECTION_TYPES';

export const goalSectionNotYet = {
    title: 'No Goal Sections Yet',
    subTitle: 'Start by adding your first Goal Section to manage their information.',
    image: Images.noClientYet,
};
